import colors from './colors';
import * as typography from './typography';

const theme = {
  colors,
  typography,
};

export default theme;
